// Mock data for Zion Underwriting Partners

export const companyInfo = {
  name: "Zion Underwriting Partners LLC",
  tagline: "Your Trusted Transportation Insurance Wholesaler",
  phone: "(555) 123-4567",
  email: "info@zionuw.com",
  address: "123 Insurance Way, Suite 100, City, State 12345"
};

export const services = [
  {
    id: 1,
    title: "Auto Physical Damage",
    description: "Comprehensive coverage for your commercial vehicles, protecting your fleet against collision, theft, vandalism, and natural disasters.",
    icon: "Truck"
  },
  {
    id: 2,
    title: "Motor Truck Cargo",
    description: "Protect the goods you transport with our motor truck cargo insurance, covering loss or damage to freight during transit.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Non-Trucking Liability",
    description: "Coverage for your commercial vehicles when not under dispatch, ensuring protection during personal use or bobtailing.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Trucker's General Liability",
    description: "Essential liability protection for loading, unloading operations, and general business activities at customer locations.",
    icon: "FileText"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Industry Expertise",
    description: "Specialized knowledge in transportation insurance with years of experience serving the trucking industry."
  },
  {
    id: 2,
    title: "Competitive Rates",
    description: "Access to multiple A-rated carriers ensuring you get the best coverage at competitive prices."
  },
  {
    id: 3,
    title: "Fast Turnaround",
    description: "Quick quote responses and efficient binding process to keep your business moving."
  },
  {
    id: 4,
    title: "Dedicated Support",
    description: "Professional, friendly service with dedicated account representatives for your insurance needs."
  },
  {
    id: 5,
    title: "Custom Solutions",
    description: "Tailored insurance programs designed to meet your specific operational requirements."
  },
  {
    id: 6,
    title: "Reliable Partners",
    description: "Strong relationships with top-rated insurance carriers to ensure policy stability and claims support."
  }
];

export const coverageTypes = [
  "Auto Physical Damage",
  "Motor Truck Cargo",
  "Non-Trucking Liability",
  "Trucker's General Liability",
  "Trailer Interchange",
  "Occupational Accident"
];

export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock form submission:", formData);
      resolve({ success: true, message: "Form submitted successfully!" });
    }, 1000);
  });
};
